module.exports = __webpack_public_path__ + "static/media/link.56cc7177.svg";